export default "__VITE_ASSET__6ba9f2ec__"